import { kebabCase } from 'lodash';

export const generateKebabCase = (...args: (string | undefined | null | number)[]): string =>
  args
    .filter((_) => !!_)
    .map((_) => kebabCase('' + _))
    .join('-');
